import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../handleRequestThunk';
import { getWheelsBoltsParts } from '../thunks/partsThunks';
import { commonInitialState } from '../../../../utils/common/commonInitialState';
import { clearPartsKey } from '../thunkKeys/partsThunksKeys';

const SLICE_NAME = 'wheelsBoltsParts';

export const wheelsBoltsPartsSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    reducers: {
        clearWheelsBoltsParts(state) {
            state.data = [];
        },
    },
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getWheelsBoltsParts });
        builder.addCase(clearPartsKey, () => commonInitialState);
    },
});

export const { clearWheelsBoltsParts } = wheelsBoltsPartsSlice.actions;

export const wheelsBoltsParts = wheelsBoltsPartsSlice.reducer;
